import { render, staticRenderFns } from "./SystemConfigDomain.vue?vue&type=template&id=6c214f4c&"
import script from "./SystemConfigDomain.vue?vue&type=script&lang=js&"
export * from "./SystemConfigDomain.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigDomain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports